import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import { pluralize } from '@fourthwall/utils/dist/string';
import { routing } from '@utils/routing';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const AppsIncentive = ({ incentive }) => {
    const { tablet } = useMediaQueryContext();
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83E\uDDF0", label: `Connect ${incentive.amountToInstall} ${pluralize(incentive.amountToInstall, 'social app', 'social apps')}`, isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Browse our apps' : 'Browse',
            to: routing.apps.self,
        } }));
};
